import { createReducer, updateObject } from './reducerUtilities';
import { MODAL_MODAL_CLOSED } from '../actions/actionTypes';

const initialState = {
   modal: {
      isOpen: false,
      isClosing: false
   },
};

// Slice reducer
export const modalReducer = createReducer(initialState, {
   [MODAL_MODAL_CLOSED]: modalClose
});

// Case reducer
function modalClose(state, action) {
   return {
      ...state, modal: updateObject(
         state.modal, {
            isOpen: action.data
         })
   };
}


// WEBPACK FOOTER //
// ./src/reducers/modalReducer.js